import { useState, useEffect } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./select";
import { getAuthHeaders, getAuthToken } from '../../../utils/authHeaders';

interface ConfigurableSelectProps {
  category: string;
  placeholder?: string;
  value?: string;
  onValueChange?: (value: string) => void;
  className?: string;
}

export function ConfigurableSelect({
  category,
  placeholder = "Select option...",
  value,
  onValueChange,
  className,
}: ConfigurableSelectProps) {
  const [configurations, setConfigurations] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchConfigurations = async () => {
      try {
        setIsLoading(true);
        const response = await fetch(`/api/configuration/category/${category}`, {
          headers: {
            'Authorization': `Bearer ${getAuthToken()}`,
            'Content-Type': 'application/json',
          
          },credentials: 'include'
        });
        
        if (!response.ok) {
          throw new Error('Failed to fetch configurations');
        }
        
        const result = await response.json();
        setConfigurations(result.success && Array.isArray(result.data) ? result.data : []);
      } catch (error) {
        console.error('Error fetching configurations:', error);
        setConfigurations([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchConfigurations();
  }, [category]);

  if (isLoading) {
    return (
      <div className="w-full h-10 bg-gray-100 animate-pulse rounded-md" />
    );
  }

  const options = configurations
    .filter((config: any) => config.isActive)
    .sort((a: any, b: any) => a.sortOrder - b.sortOrder);

  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger className={className}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {options.map((config: any) => (
          <SelectItem key={config.key} value={config.key}>
            {config.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}